const reviews_swiper = new Swiper('.review_slides-initialize', {
  // If we need pagination
  pagination: {
    el: '.review_slides-initialize .swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: '.review_slides-initialize .swiper-button-next',
    prevEl: '.review_slides-initialize .swiper-button-prev'
  },
  slidesPerView: 4,
  slidesPerGroup: 1,
  allowTouchMove: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
      }
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 16,
      freeMode: true
    },
    1300: {
      slidesPerView: 4,
      spaceBetween: 16,
      freeMode: true
    }
  }
});



  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },


